import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import TopBarLayout from "../../../components/TopBarLayout";
import ContentLayout from "../../../components/ContentLayout";

import { Box, Typography, Grid } from "@mui/material";
import ArticleEdit from "../../../components/ArticleEdit";
import { useTitle } from "../../../utils/hooks";

export default function BlogEdit() {
  const location = useLocation();
  useTitle("编辑文章");
  return <ArticleEdit state={location.state} />;
}
